module.exports = __webpack_public_path__ + "static/media/facebook.17b57389.svg";